import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import { config } from './constants'

// Exclude the CMS: CloudFront keys its cache on sentry-trace, so a trace
// header on CMS reads defeats caching (ENG-3110)
export const tracingOrigins = [
  /^https?:\/\/(?!(?:[^/]*\.)?content\.section-l\.co)[^/]+\.section-l\.co/,
  /^\//,
]

export default function sentry(app, router) {
  Sentry.init({
    app,
    dsn: config.sentryDsn,
    release: config.appVersion,
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins,
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.7,
  })
}
